import React, { Component } from 'react';
import { Switch } from 'antd';
import './ARSwitch.css';

export default class ARSwitch extends Component {
    render() {
        const { className, label, labelSecondary, underline, float, ...props } = this.props;

        const containerClassString = ['ar_switch_container',className];
        const wrapperClassString = ['ar_switch_wrapper'];

        if (underline){
            wrapperClassString.push('text_underline');
        }

        if(props && float === false){
            containerClassString.push('no_float');
        }

        if(props && !props.size){
            props.size = "large";
        }
        wrapperClassString.push('ar_switch_' + props.size);

        let labelComponent = label && (
            <label className="label">{label} <small>{labelSecondary}</small></label>
        );

        //containerClassString.push('ar_switch_container' + props.size);

        return (
            <div className={wrapperClassString.join(' ')}>
                <Switch {...props} className={containerClassString.join(' ')} />
                {labelComponent}
            </div>
        )
    }
}